import React, { Fragment, Suspense } from "react";
import { metaTag } from "../Library/commomLib";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
const RankingComponent = React.lazy(() => import("../Components/RootComponents/RankingComponent"));
const RankingPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <RankingComponent />
      </Suspense>
    </Fragment>
  );
};

export default RankingPage;
